export const SortOptions = {
  highToLow: 'Price (High to Low)',
  lowToHigh: 'Price (Low to High)',
  newest: 'Newest',
  rating: 'Rating',
  featured: 'Featured',
  aToZ: 'A to Z',
  zToA: 'Z to A',
};

export const ColorwaySort = {
  default: 'Default',
  current: 'Current',
  carryover: 'Carryover',
  sale: 'Sale',
  finalSale: 'Final Sale',
};
